import React from 'react'
import styled from 'styled-components'
import Skeleton from 'components/_UI/Skeleton'
import DashboardEventCardSkeleton from './DashboardEventCardSkeleton'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'

export default function EventListSkeleton({ sections = [4, 3, 2] }) {
    return (
        <Container>
            {sections.map((cardCount, index) => (
                <SectionSkeleton key={index}>
                    <HeaderSkeleton>
                        <IconSkeleton>
                            <Skeleton
                                width="32px"
                                height="32px"
                                style={{ borderRadius: '8px' }}
                            />
                        </IconSkeleton>
                        <HeaderTextSkeleton>
                            <Skeleton
                                width="140px"
                                height="14px"
                                style={{ marginBottom: '4px' }}
                            />
                            <Skeleton
                                width="80px"
                                height="12px"
                            />
                        </HeaderTextSkeleton>
                    </HeaderSkeleton>
                    <CardsGrid>
                        {Array.from({ length: cardCount }).map((_, i) => (
                            <DashboardEventCardSkeleton key={i} />
                        ))}
                    </CardsGrid>
                </SectionSkeleton>
            ))}
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
`

const SectionSkeleton = styled.div`
    background: ${colors.neutralLight};
    border-radius: 12px;
    border: 1px solid ${colors.neutralDark};
    width: 100%;
    overflow: hidden;
`

const HeaderSkeleton = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 20px 24px 0 24px;

    @media screen and (max-width: ${breakpoints.sm}) {
        padding: 16px 16px 0 16px;
    }
`

const IconSkeleton = styled.div`
    flex-shrink: 0;
`

const HeaderTextSkeleton = styled.div`
    display: flex;
    flex-direction: column;
`

const CardsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
    padding: 24px;

    @media screen and (max-width: ${breakpoints.sm}) {
        grid-template-columns: 1fr;
        padding: 16px;
    }
`
